export enum Actions {
    UpdateState,
    UpdateIsBusy,
    UpdateRecoverState,
    UpdateRegisterState,
    ResetRecoverState,
    ResetRegisterState,
    SetErrorMessage,
    UpdateClientData,
    UpdateClientPublicId,
    UpdateSetExistingClientCredentialsState,
    ResetSetExistingClientCredentialsState,
}
